module.exports = __webpack_public_path__ + "static/img/6.76919d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/6.png
// module id = seVk
// module chunks = 0